import * as requestFromServer from "./OccupationCategoriesCrud";
import { callTypes, occupationCategorySlice } from "./OccupationCategoriesSlice";

const {actions} = occupationCategorySlice;

export const getCategories = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getCategories(queryParams)
    .then(response => {
      dispatch(actions.categoriesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllCategories = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllCategories(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCategory = (id) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  if (!id) {
    return requestFromServer
      .getNewCategory(id)
      .then(response => {
        dispatch(actions.categoryFetched(response.data));
      })
      .catch(error => {
        
      });
  }

  return requestFromServer
    .getCategory(id)
    .then(response => {
      dispatch(actions.categoryFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveCategory = category => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveCategory(category)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteCategories = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCategories(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCategoriesState = () => dispatch => {
  dispatch(actions.categoriesStateCleaned());
}